import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { style: { "display": "flex", "flex-direction": "column", "align-items": "center", "justify-content": "start" } };
const _hoisted_2 = { class: "mb-4" };
const _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.title,
        "show-header": _ctx.hasTitle
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: "Schließen",
                onClick: _ctx.onClose,
                "button-style": "btn-danger",
                class: "w-120-px"
            }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", { innerHTML: _ctx.message }, null, 8, _hoisted_3)
                ])
            ])
        ]),
        _: 1
    }, 8, ["title", "show-header"]));
}
